import React from "react";

import redeGloboImg from "../../../../../../images/icon_channel_globo.png";
import globoNewsImg from "../../../../../../images/icon_channel_globo_news.svg";
import sportTVImg from "../../../../../../images/icon_channel_sport_tv.svg";
import historyImg from "../../../../../../images/icon_channel_history.svg";

import {
  ProductTVImgRedeGloboElement,
  ProductTVImgGloboNewsElement,
  ProductTVImgSportTVElement,
  ProductTVImgHistoryElement,
} from "../../ProductTVValue.styles";

const ShowImagesPlanTop = () => {
  return (
    <>
      <ProductTVImgRedeGloboElement src={redeGloboImg} alt="" />
      <ProductTVImgGloboNewsElement src={globoNewsImg} alt="" />
      <ProductTVImgSportTVElement src={sportTVImg} alt="" />
      <ProductTVImgHistoryElement src={historyImg} alt="" />
    </>
  );
};

export default ShowImagesPlanTop;
